import { useEffect } from 'react'
import { generateTouchedObject } from '../../libs/formik'

const useShippingSendStep = ({
  formik,
  enhancedFormik,
  onSetDirty,
  hasConfirmation,
  onAcceptConfirmation,
  serverFieldErrors,
  // eslint-disable-next-line react/forbid-foreign-prop-types
  propTypes,
}) => {
  // Track dirty state on parent reducer
  useEffect(() => {
    onSetDirty(formik.dirty)
  }, [onSetDirty, formik.dirty])

  // Set all fields as touched (as if we were submitting) anytime we're
  // showing the confirmation modal.
  const values = formik.values
  const setTouched = formik.setTouched
  useEffect(() => {
    if (hasConfirmation) {
      setTouched(generateTouchedObject(propTypes, values))
    }
  }, [hasConfirmation, setTouched, propTypes, values])

  const handleDiscardChanges = () => {
    enhancedFormik.resetForm()
  }

  const handleDiscardConfirmation = () => {
    handleDiscardChanges()
    onAcceptConfirmation()
  }

  const hasServerError =
    !!serverFieldErrors && Object.keys(serverFieldErrors).length > 0

  const hasAnyError =
    !!enhancedFormik.fieldErrors &&
    Object.keys(enhancedFormik.fieldErrors).length > 0

  return {
    handleDiscardConfirmation,
    hasServerError,
    hasAnyError,
  }
}

export default useShippingSendStep
